import { Hidden } from '@material-ui/core';
import React from 'react';
import { getFormattedDate } from '../../../../../global/helpers/date-helpers';
import { InstitutionProps } from '../../../models/arc-epi-props';
import { PlanSummaryDto } from '../institution-model';




interface Props {
	item: PlanSummaryDto,
	settings: InstitutionProps,
}


export function DbPlanHistoryItemView(props: Props) {

	const { item, settings } = props;
	return (
		<div className='sort-table-row'>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{settings?.planNameLabel}</p>
				</Hidden>
				<p>
					{item?.name}

				</p>
			</div>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{settings?.adoptionDateLabel}</p>
				</Hidden>
				<p>
					{getFormattedDate(item?.effective_date)}
				</p>
			</div>

			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{settings?.assessmentLabel}</p>
				</Hidden>
				<p>
					{item?.assessment_percent}
				</p>
			</div>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{settings?.billingSchdeuleLabel}</p>
				</Hidden>
				<p>
					{item?.billing_schedule}
				</p>
			</div>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{settings?.terminationDateLabel}</p>
				</Hidden>
				<p>{getFormattedDate(item?.termination_date)}</p>
			</div>
		</div>);
}